import React, { ReactNode, useContext, useEffect, useLayoutEffect, useState } from 'react'
import { Divider, Grid, useMediaQuery, } from '@mui/material'
import globalStyles from "../../../../../assets/styles/global.module.scss";
import styles from "../../../../../assets/styles/componentStyles/chatbotStyles/integrations.module.scss";
import { MetaContext, MetaContextPayload } from '../../../../../context/metaContext';
import { IntegrationContext, IntegrationContextPayload } from '../../../../../context/integrationContext';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { UserContext, UserContextPayload } from '../../../../../context/userContext';
import { globalSlackIntegration, slackChannelData } from '../../../../../models/axiosModel';
import FacebookInformationCard from '../../../../utility/facebookInformationCard';
import cardStyles from './../../../../../assets/styles/componentStyles/accountInformationCard.module.scss'
import GlobalButton from '../../../../utility/globalButton/button';
import IconsColor from '../../../../utility/iconsColor';
import tempStyles from "../../../../../assets/styles/componentStyles/accountInformationCard.module.scss";
import { primaryColor } from '../../../../../utils/colors';
import agent from '../../../../../services/api';
import GlobalDeletePopup from '../../../../utility/globalDeletePopup/globalDeletePopup';
import { integrationFields } from '../../zohoIntegrations/viewZohoIntegration';
import { hasAIChatbotManageAccess } from '../../../../../utils/constants';
import { useGenericStore } from '../../../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';

interface checkFlag {
    flagPage?: boolean
}
const ViewSlackIntegration = (props: checkFlag) => {
    const {
        showFacebookIntegrationDetails,
    } = useContext(MetaContext) as MetaContextPayload;

    const {
        getSlackIntegrations,
        slackIntegrations,
    } = useContext(IntegrationContext) as IntegrationContextPayload;

    // CONST
    const navigate = useNavigate()
    const { setFlagLoading, handleError, apiRoutesPermissionAssignment, userDetail } = useContext(UserContext) as UserContextPayload

    const { showSuccess } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess
    })))

    const [slackIntegrationDetails, setSlackIntegrationDetails] = useState<globalSlackIntegration[] | null>(null)
    const [searchParams, setSearchParams] = useSearchParams()
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState<boolean>(false)
    const smallScreen = useMediaQuery('(max-width : 600px) and (min-width : 0px)')
    const tabletScreen = useMediaQuery('(max-width : 900px) and (min-width : 600px)')
    const laptopScreen = useMediaQuery('(max-width : 1600px) and (min-width : 900px)')

    // const [responsePayload, setResponsePayload] = useState<any>({
    //     page_id: '',
    //     page_name: '',
    //     page_category: '',
    //     access_token_value: '',
    //     instagram_id: '',
    //     instagram_username: ''
    // }) 

    const slackIntegrationsFields: integrationFields[] = [
        {
            key: "Workspace",
            value: slackIntegrationDetails?.[0]?.slack_team_name,
            iconName: "workspace",
        },
        {
            key: "UserName",
            value: slackIntegrationDetails?.[0]?.slack_user_real_name,
            iconName: "profile",
        },
        {
            key: "No. of Channels",
            value: slackIntegrationDetails?.[0]?.slack_channels.length,
            iconName: "slackChannel",
        }
    ]

    useLayoutEffect(() => {
        (async () => {
            setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))
            const res = await getSlackIntegrations()
            if (!(res.status)) {
                handleError(res);
            }
            setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }))
        })()
    }, [])

    useEffect(() => {
        if (searchParams.has('id')) {
            if (slackIntegrations && slackIntegrations.length > 0) {
                let id = Number(searchParams.get('id'))
                let integration = slackIntegrations.filter((slackIntegration: globalSlackIntegration) => slackIntegration.slack_integration_id == id)
                if (integration.length > 0) {
                    setSlackIntegrationDetails(integration)
                } else {
                    navigate('/channels')
                }
            }
        } else {
            navigate('/channels')
        }
    }, [slackIntegrations])

    async function deleteSlackIntegration() {
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))
        if (slackIntegrationDetails && slackIntegrationDetails.length > 0) {
            let slack_integration_id = slackIntegrationDetails[0].slack_integration_id
            const response = await agent.deleteSlackIntegration.delete(slack_integration_id)
            if (response.status) {
                showSuccess("Integration deleted successfully!")
                navigate('/channels')
            } else {
                handleError(response);
            }
        }
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }))

    }

    const renderSlackIntegrationsFields = (field: integrationFields, ind: number): ReactNode => {
        return (
            <Grid item key={ind}>
                <Grid container className={globalStyles.createChatbotContainer} gap={"4px"}>
                    <Grid item className={cardStyles.objectKeyStyle}>
                        <Grid container className={`${globalStyles.createChatbotContainer} ${globalStyles.gapTwo}`} >
                            <IconsColor iconName={field.iconName} width="24px" height="24px" fillColor={primaryColor} />
                            {field.key} &nbsp;
                        </Grid>
                    </Grid>
                    <Grid item className={cardStyles.genericValueStyle}>{field.value}</Grid>
                </Grid>
            </Grid>
        );
    }

    const innerHeight = smallScreen ? (window.innerHeight - 90) : tabletScreen ? (window.innerHeight - 100) : laptopScreen ? (window.innerHeight - 100) : (window.innerHeight - 110);
    const integrationViewInnerHeight = smallScreen ? (window.innerHeight - 110) : tabletScreen ? (window.innerHeight - 100) : laptopScreen ? (window.innerHeight - 120) : (window.innerHeight - 140);

    return (
        <>
            <Grid item
                className={showFacebookIntegrationDetails == false ? `${globalStyles.fullwidth} ${styles.integrationDefaultView}` : `${globalStyles.fullwidth} ${styles.integrationView}`}
                height={showFacebookIntegrationDetails == false ? `${innerHeight}px !important` : `${integrationViewInnerHeight}px !important`}
            >
                <Grid container>
                    {slackIntegrationDetails &&
                        <>
                            <Grid item className={globalStyles.fullwidth} xs={12} lg={12} xl={12}>
                                <Grid container gap={3} >
                                    {props.flagPage ?
                                        <>
                                            {slackIntegrationDetails && slackIntegrationDetails[0].slack_channels.map((channel: slackChannelData, index: number) => {
                                                return <FacebookInformationCard
                                                    integrationType='Slack'
                                                    key={index}
                                                    flagDelete={false}
                                                    title={`WhatsApp Account ${index + 1}`}
                                                    currentlySelected={true}
                                                    showRemoveChatbotIntegration={true}
                                                    flagShowLinkedChatbot={true}
                                                    //   removeChatbotIntegration={() => { handleRemoveChatbotIntegration(pageData.meta_integration_id, pageData.meta_integration_type_id, pageData.instagram_id, pageData.page_id, pageData.instagram_username) }}
                                                    details={{
                                                        integrated_channel_id: "",
                                                        page_id: channel.channel_id,
                                                        page_name: channel.slack_channel_name,
                                                        page_category: channel.slack_channel_purpose,
                                                        linked_chatbots: channel.chatbot_slack_assignment_data
                                                    }}
                                                    flagIntegration={false}
                                                />
                                            })

                                            }
                                        </>
                                        :
                                        <>
                                            {
                                                <Grid item className={globalStyles.fullwidth}>
                                                    <Grid container className={`${globalStyles.flexColumn} ${globalStyles.gapLength} `}>
                                                        <Grid item xs={12}>
                                                            <Grid container className={globalStyles.flexColumn}>
                                                                <Grid item className={tempStyles.header}>
                                                                    <Grid container className={globalStyles.spaceAlignmentCenter} >

                                                                        <Grid item className={globalStyles.displayFlex}>
                                                                            <Grid container>
                                                                                <Grid item className={`${globalStyles.displayFlex} ${tempStyles.rightMargin}`} >
                                                                                    <IconsColor iconName="colouredSlackIcon" width="20px" height="20px" />

                                                                                </Grid>
                                                                                <Grid item className={tempStyles.headerText}>{'Slack'}</Grid>
                                                                            </Grid>

                                                                        </Grid>

                                                                        {hasAIChatbotManageAccess(apiRoutesPermissionAssignment, userDetail) && 
                                                                            <Grid item>
                                                                                <GlobalButton buttonText={"Delete"} className="deleteIntegrationButton" onClick={() => { setShowDeleteConfirmation(true) }} startIcon={<IconsColor iconName="DeleteIcon" fillColor={primaryColor} height="16" width="16" />} />
                                                                            </Grid>
                                                                        }
                                                                    </Grid>
                                                                </Grid>
                                                                <Divider className={tempStyles.slackZohoAccSetUpDivider} />
                                                            </Grid>

                                                        </Grid>
                                                        {slackIntegrationsFields.map((field: integrationFields, ind: number) => {
                                                            return renderSlackIntegrationsFields(field, ind);
                                                        })}
                                                    </Grid>
                                                </Grid>
                                            }
                                        </>
                                    }
                                </Grid>
                            </Grid>

                            {showDeleteConfirmation &&
                                <GlobalDeletePopup
                                    deleteDescription={`Are you sure you want to delete ${slackIntegrationDetails[0].slack_user_real_name} - ${slackIntegrationDetails[0].slack_team_name}`}
                                    open={showDeleteConfirmation}
                                    onClose={() => { setShowDeleteConfirmation(false) }}
                                    onDelete={() => {
                                        deleteSlackIntegration()
                                        setShowDeleteConfirmation(false)
                                    }}
                                />
                            }
                        </>}
                </Grid>
            </Grid>

        </>
    )
}

export default ViewSlackIntegration